/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Reset_FiltersInputs */

const en_cases_reset_filters = /** @type {(inputs: Cases_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset filters`)
};

const pt_br2_cases_reset_filters = /** @type {(inputs: Cases_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar filtros`)
};

/**
* | output |
* | --- |
* | "Reset filters" |
*
* @param {Cases_Reset_FiltersInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_reset_filters = /** @type {((inputs?: Cases_Reset_FiltersInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Reset_FiltersInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_reset_filters(inputs)
	return pt_br2_cases_reset_filters(inputs)
});